{
  "nl": {
    "pinboard": {
      "activity": {
        "board": {
          "addAttachment": "<strong>{user}</strong> heeft de bijlage <a href=\"{url}\" target=\"_blank\">{value}</a> toegevoegd aan de kaart <a href=\"{cardUrl}\">{cardName}</a>",
          "addAttachmentAfterRemoval": "<strong>{user}</strong> heeft de bijlage {value} toegevoegd aan de kaart <a href=\"{cardUrl}\">{cardName}</a>",
          "createCard": "<strong>{user}</strong> heeft de kaart <a href=\"{cardUrl}\">{cardName}</a> aangemaakt",
          "destroyCard": "<strong>{user}</strong> heeft de kaart <em>{cardName}</em> verwijderd",
          "moveCard": "<strong>{user}</strong> heeft de kaart <a href=\"{cardUrl}\">{cardName}</a> verplaatst van <em>{oldValue}</em> naar <em>{value}</em>",
          "removeAttachment": "<strong>{user}</strong> heeft de bijlage <em>{oldValue}</em> verwijderd van de kaart <a href=\"{cardUrl}\">{cardName}</a>",
          "updateCardColor": "<strong>{user}</strong> heeft de kleur van de kaart gewijzigd",
          "updateCardCoverImage": "<strong>{user}</strong> heeft de voorbeeldafbeelding van de kaart <a href=\"{cardUrl}\">{cardName}</a> gewijzigd naar <a href=\"{url}\" target=\"_blank\">{value}</a>",
          "updateCardDescription": "<strong>{user}</strong> heeft de beschrijving van de kaart <a href=\"{cardUrl}\">{cardName}</a> gewijzigd",
          "updateCardName": "<strong>{user}</strong> heeft de naam van de kaart <a href=\"{cardUrl}\">{cardName}</a> gewijzigd (van: <em>{oldValue}</em>)",
          "updateCardVisitorPermissions": "<strong>{user}</strong> heeft de bezoekersrechten van de kaart <a href=\"{cardUrl}\">{cardName}</a> gewijzigd (van: <em>{oldValue}</em>)"
        },
        "card": {
          "addAttachment": "<strong>{user}</strong> heeft de bijlage <a href=\"{url}\" target=\"_blank\">{value}</a> toegevoegd",
          "addAttachmentAfterRemoval": "<strong>{user}</strong> heeft de bijlage {value} toegevoegd",
          "createCard": "<strong>{user}</strong> heeft deze kaart aangemaakt",
          "moveCard": "<strong>{user}</strong> heeft deze kaart verplaatst van <em>{oldValue}</em> naar <em>{value}</em>",
          "removeAttachment": "<strong>{user}</strong> heeft de bijlage <em>{oldValue}</em> verwijderd",
          "updateCardColor": "<strong>{user}</strong> heeft de kleur van de kaart gewijzigd",
          "updateCardCoverImage": "<strong>{user}</strong> heeft de voorbeeldafbeelding gewijzigd naar <a href=\"{url}\" target=\"_blank\">{value}</a>",
          "updateCardDescription": "<strong>{user}</strong> heeft de beschrijving van de kaart gewijzigd",
          "updateCardName": "<strong>{user}</strong> heeft de naam van de kaart gewijzigd (van: <em>{oldValue}</em>)",
          "updateCardVisitorPermissions": "<strong>{user}</strong> heeft de bezoekersrechten van de kaart gewijzigd (van: <em>{oldValue}</em>)"
        },
        "missingUser": "Verwijderde gebruiker"
      },
      "buttons": {
        "addAttachment": "Toevoegen",
        "addCard": "Kaart toevoegen",
        "addList": "Lijst toevoegen",
        "color": "Kleur",
        "create": "Aanmaken",
        "loadMore": "Meer laden",
        "openListSettings": "Lijstinstellingen openen"
      },
      "card": {
        "openFile": "Bestand openen",
        "openLink": "Link openen",
        "setCoverAttachment": "Deze bijlage als voorbeeldafbeelding gebruiken"
      },
      "colorPalette": {
        "colorDropdown": "Kleurenpalet"
      },
      "confirm": {
        "deleteAttachment": {
          "text": "Deze actie kan niet ongedaan worden gemaakt. De bijlage wordt permanent van de kaart verwijderd.",
          "title": "Bijlage verwijderen?"
        },
        "deleteCard": {
          "text": "Deze actie kan niet ongedaan worden gemaakt. Alle inhoud van de kaart wordt permanent verwijderd.",
          "title": "Kaart verwijderen?"
        },
        "deleteComment": {
          "text": "Deze actie kan niet ongedaan worden gemaakt. De reactie wordt permanent van de kaart verwijderd.",
          "title": "Reactie verwijderen?"
        },
        "deleteList": {
          "text": "Deze actie kan niet ongedaan worden gemaakt. De lijst wordt samen met alle bijbehorende kaarten permanent verwijderd.",
          "title": "Lijst verwijderen?"
        },
        "removeMember": {
          "text": "Het lid verliest de toegang tot dit prikbord en de bijbehorende kaarten.",
          "title": "Lid verwijderen?"
        }
      },
      "errors": {
        "boardUpdateFailed": "Fout bij het bijwerken van het bord",
        "cardLimitReached": "Je kunt maximaal {limit} kaarten in deze lijst aanmaken.",
        "listLimitReached": "Je kunt maximaal {limit} lijsten op dit prikbord aanmaken."
      },
      "flash": {
        "attachmentDeleted": "Bijlage verwijderd",
        "boardUpdated": "Prikbord bijgewerkt",
        "cardNotFound": "Kaart niet gevonden",
        "colorUpdated": "Kleur bijgewerkt",
        "commentDeleted": "Reactie verwijderd",
        "commentUpdated": "Reactie bijgewerkt",
        "coverImageUpdated": "Voorbeeldafbeelding bijgewerkt",
        "descriptionUpdated": "Beschrijving bijgewerkt",
        "linkAdded": "Link toegevoegd",
        "listRemoved": "Lijst verwijderd",
        "memberRemoved": "Lid verwijderd",
        "permissionsUpdated": "Rechten bijgewerkt",
        "titleUpdated": "Titel bijgewerkt"
      },
      "headers": {
        "activities": "Activiteiten",
        "attachFile": "Bestand bijvoegen",
        "attachLink": "Link bijvoegen",
        "members": "Leden",
        "permissions": "Rechten",
        "pickColor": "Kleur selecteren",
        "visitorPermissions": "Bezoekers mogen..."
      },
      "labels": {
        "activity": "Activiteit",
        "attachments": "Bijlagen",
        "cardTitle": "Kaarttitel",
        "inList": "in {listName}",
        "visitorCanAddCards": "Kaarten verwijderen en toevoegen",
        "visitorCanAddList": "Lijsten verwijderen en toevoegen",
        "visitorCanComment": "Reageren op kaarten",
        "visitorCanViewActivities": "Activiteitenlogboek van kaarten bekijken"
      },
      "links": {
        "activities": "Activiteiten",
        "boardMembers": "Leden"
      },
      "paragraphs": {
        "addMembers": "Nodig leden uit voor je prikbord om het samen met hen te beheren. Hiervoor is een fobizz-account nodig.",
        "noMembers": "Je hebt nog geen andere leden uitgenodigd voor dit prikbord.",
        "noMoreActivities": "Geen verdere activiteiten"
      },
      "placeholders": {
        "cardName": "Naam voor kaart invoeren...",
        "comment": "Reactie hier invoeren...",
        "description": "Beschrijving hier invoeren...",
        "link": "URL hier invoeren...",
        "listName": "Naam voor lijst invoeren...",
        "searchImages": "Zoekterm of kleur invoeren..."
      },
      "toolName": "Prikbord",
      "visitorPermissions": {
        "cardDescription": {
          "visitor_permissions_invisible": "Bezoekers kunnen de kaart niet zien.",
          "visitor_permissions_read": "Bezoekers kunnen de kaart zien.",
          "visitor_permissions_write": "Bezoekers kunnen de kaart bewerken."
        },
        "listDescription": {
          "visitor_permissions_invisible": "Bezoekers kunnen de lijst niet zien.",
          "visitor_permissions_read": "Bezoekers kunnen de lijst zien.",
          "visitor_permissions_write": "Bezoekers kunnen kaarten toevoegen"
        },
        "permissions": "Bezoekersrechten"
      }
    }
  }
}
